module.exports = __webpack_public_path__ + "img/mb_web.aabcb24a.png";